/**
 * Red "*" marker shown after the label of a required form field.
 * Pass `marginLeft` to nudge its spacing relative to the label text.
 */
export const RequiredAsterisk = ({ marginLeft }: { marginLeft?: number }) => (
  <span aria-label='required' style={{ color: 'var(--danger)', marginLeft }}>
    *
  </span>
);
